module.exports = __webpack_public_path__ + "static/img/exampleWord.fef38f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/exampleWord.png
// module id = 226
// module chunks = 1